import type { ToolDefinition } from '../types';
import { CommentTool } from './comment';
import { MeasureTool } from './measure';
import { SelectTool } from './select';

/**
 * Every tool; the first is active on start, and Escape returns to it. The keyboard
 * shortcuts read this, so a new tool is one module plus one entry.
 */
export const TOOLS = [
  {
    id: 'select',
    label: 'Select',
    shortcut: 'V',
    cursor: 'crosshair',
    create: () => new SelectTool(),
  },
  {
    id: 'measure',
    label: 'Measure',
    shortcut: 'M',
    cursor: 'measure',
    create: () => new MeasureTool(),
  },
  {
    id: 'comment',
    label: 'Comment',
    shortcut: 'C',
    cursor: 'crosshair',
    create: () => new CommentTool(),
  },
] as const satisfies readonly ToolDefinition[];

export type ToolId = (typeof TOOLS)[number]['id'];

export const toolForShortcut = (key: string): ToolId | null =>
  TOOLS.find((tool) => tool.shortcut.toLowerCase() === key.toLowerCase())?.id ?? null;
